// extracted by mini-css-extract-plugin
module.exports = {"container":"Dropzone_container__8Y-eR","fileChipRow":"Dropzone_fileChipRow__2qL8o","uploadIcon":"Dropzone_uploadIcon__1v0yZ"};